<template>
  <div class="is-main">
    <main class="section full-width">
      <section class="level is-mobile">
        <div class="level-left">
          <div class="level-item"></div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <button class="button is-success" v-on:click="open_Create" v-if="can_create_is==true">
              <b-icon pack="fas" icon="calendar-plus"></b-icon>
            </button>
          </div>
        </div>
      </section>
      <ul>
        <li v-for="(ivent) in ivent_list" :key="ivent.data().name">
          <ivent
            v-on:order_Open_Edit="open_Edit"
            v-on:order_Open_Delete="open_Delete"
            v-bind:ivent="ivent"
          ></ivent>
        </li>
      </ul>
    </main>
    <!-- modal area -->
    <b-modal :active.sync="is_Create" has-modal-card>
      <article class="section">
        <create v-on:order_Close_Create="close_Create"></create>
      </article>
    </b-modal>
    <b-modal :active.sync="is_Edit" has-modal-card>
      <article class="section">
        <edit v-on:order_Close_Edit="close_Edit"></edit>
      </article>
    </b-modal>
    <b-modal :active.sync="is_Delete" has-modal-card>
      <article class="section">
        <deleteis v-on:order_Close_Delete="close_Delete"></deleteis>
      </article>
    </b-modal>
    <!-- modal area -->
  </div>
</template>

<script>
// @ is an alias to /src
import ivent from "@/components/ivent/Ivent.vue";
import create from "@/components/ivent/Create.vue";
import edit from "@/components/ivent/Edit.vue";
import deleteis from "@/components/ivent/Delete.vue";
import "@/store/Fire_Base_API.js";
import ivent_API from "@/store/Ivent_API.js";
import auth from "@/mixin/Auth.vue";
import toastre from "@/mixin/Toaster.vue";

export default {
  name: "Ivent_Home",
  components: {
    ivent,
    create,
    edit,
    deleteis
  },
  data: function() {
    return {
      ivent_list: [],
      can_create_is: false,
      is_Edit: false,
      is_Create: false,
      is_Delete: false
    };
  },
  mixins: [auth, toastre],
  methods: {
    // イベント取得
    get_List: function() {
      ivent_API.get_Ivent_List(this.user).then(
        from_ivent_list => {
          this.ivent_list = [];
          Object.keys(from_ivent_list).forEach(index => {
            this.ivent_list.splice(index, 1, from_ivent_list[index]);
          });

          this.can_create_is = true;
        },
        () => {
          this.display_Error(
            "イベントの取得に失敗しました。画面を更新してください。連続して失敗する場合はご連絡ください。"
          );
        }
      );
    },
    // 作成画面を開く
    open_Create: function() {
      this.is_Create = true;
    },
    // 作成画面を閉じる
    close_Create: function() {
      this.is_Create = false;

      this.get_List();
    },
    // 編集画面を開く
    open_Edit: function() {
      this.is_Edit = true;
    },
    close_Edit: function() {
      this.is_Edit = false;

      this.get_List();
    },
    // 削除画面を開く
    open_Delete: function() {
      this.is_Delete = true;
    },
    // 削除画面を閉じる
    close_Delete: function() {
      this.is_Delete = false;

      this.get_List();
    }
  }
};
</script>

<style>
.is-main {
  flex: 1;
}

.full-height {
  min-height: 100%;
}

.full-width {
  min-width: 100%;
}
</style>
